<template>
	<transition name="slide-up">
		<div class="banner" v-if="show">
			<div class="message wysiwyg-content">
				<p class="content">
					<strong>This browser is out of date and doesn't
					have support for some web features required to run this game.</strong>
					<br />
					This game is best played in a modern browser like <a href="https://www.google.com/chrome/">Chrome</a>.
				</p>
			</div>
			<button class="close-btn" @click="close()">
				<svg viewBox="0 0 18.85 18.85" xmlns="http://www.w3.org/2000/svg" v-bind:class="'close-x'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.003 1.529L1.531 0l17.324 17.324-1.528 1.528z" fill="#8eceff"/><path d="M.003 17.311L17.327-.013l1.528 1.528L1.53 18.839z" fill="#8eceff"/></svg>
			</button>
		</div>
	</transition>
</template>

<script>
import { IS_IE11 } from "@/constants";

export default {
	name: 'BrowserMessage',
	data: () => ({ show: IS_IE11 }),
	methods: {
		close() {
			this.show = false;
		},
	},
};
</script>

<style lang="scss" scoped>
	.banner {
		display: block;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: $z-top + $z-top;
	}

	.message {
		display: block;
		width: 100vw;
		padding: 2em 2em;

		font-family: $body-font;
		font-size: $font-size-sm;
		text-align: center;
		color: $primary-color;

		background-color: $alt-color-light;

		transition: all $ui-transition-duration;

		::v-deep a {
			color: $primary-color;
			text-decoration: underline;
		}
	}

	.close-btn {
		background: none;
		border: none;
		height: 25px;
		width: 25px;
		margin: 20px;
		padding: 0;
		position: absolute;
		top: 0;
		right: 0;
		::v-deep path { fill: $primary-color; stroke: $primary-color; }

		@include mobile {
			display: none;
		}
	}

	.close-x {
		height: 100%;
		width: 100%;
		stroke-width: 0.5px;
	}
</style>
